(() => {
  if (window.nutricareArticleUI) return;
  const init = (scope = document) => {
    const roots = scope.matches?.('[data-nau]') ? [scope] : scope.querySelectorAll('[data-nau]');
    roots.forEach((root) => {
      if (root.dataset.nauReady) return;
      root.dataset.nauReady = 'true';
      const body = root.querySelector('[data-nau-body]');
      if (!body) return;
      const headings = [...body.querySelectorAll('h2')];
      const used = new Set([...document.querySelectorAll('[id]')].map((el) => el.id));
      const targets = headings.filter((heading, index) => {
        if (!heading.textContent.trim() || heading.hidden) return false;
        if (heading.id) return [...document.querySelectorAll('[id]')].filter((el) => el.id === heading.id).length === 1;
        let id = `nau-${root.dataset.sectionId}-${index + 1}`;
        while (used.has(id)) id += '-section';
        heading.id = id;
        used.add(id);
        return true;
      });
      if (targets.length > 1) {
        root.querySelectorAll('[data-nau-toc]').forEach((nav) => {
          targets.forEach((heading) => {
            const a = document.createElement('a');
            a.href = `#${encodeURIComponent(heading.id)}`;
            a.textContent = heading.textContent;
            a.addEventListener('click', (event) => {
              event.preventDefault();
              const details = a.closest('details');
              if (details) details.open = false;
              heading.setAttribute('tabindex', '-1');
              heading.focus({ preventScroll: true });
              heading.scrollIntoView({ behavior: 'instant', block: 'start' });
              history.replaceState(null, '', a.hash);
            });
            nav.append(a);
          });
          nav.hidden = false;
        });
        const mobile = root.querySelector('[data-nau-mobile]');
        if (mobile) mobile.hidden = false;
      }
      const reminder = root.dataset.reminderHeading;
      const matches = headings.filter((h) => h.parentElement === body && h.textContent.trim() === reminder);
      const reminderHeading = matches.length === 1 ? matches[0] : null;
      let adjacentNode = reminderHeading?.nextSibling;
      while (adjacentNode?.nodeType === Node.TEXT_NODE && !adjacentNode.textContent.trim()) {
        adjacentNode = adjacentNode.nextSibling;
      }
      if (reminder && reminderHeading && targets.includes(reminderHeading) && adjacentNode?.nodeName === 'P') {
        const h = matches[0];
        const paragraph = h.nextElementSibling;
        const box = document.createElement('section');
        box.className = 'nau-reminder';
        box.setAttribute('aria-labelledby', h.id);
        const contentNodes = [];
        for (let node = h; node; node = node.nextSibling) {
          contentNodes.push(node);
          if (node === paragraph) break;
        }
        h.before(box);
        box.append(...contentNodes);
      }
      root.querySelectorAll('[data-nau-share]').forEach((share) => {
        const button = share.querySelector('[data-nau-copy]');
        const fallback = share.querySelector('[data-nau-share-fallback]');
        const input = share.querySelector('input');
        const status = share.querySelector('[data-nau-status]');
        button.hidden = false;
        fallback.hidden = true;
        button.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(input.value);
            status.textContent = status.dataset.success;
          } catch {
            fallback.hidden = false;
            fallback.open = true;
            status.textContent = status.dataset.failure;
            input.focus();
            input.select();
          }
        });
      });
    });
  };
  window.nutricareArticleUI = { init };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
